import { useSelector } from 'react-redux';

const useCurrentUser = () => {
  const currentUser = useSelector(state => state.auth.currentUser);
  return currentUser;
};

export default useCurrentUser;
